// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"63a35272","897":"fcf24392"}[chunkId] + ".chunk.js";
};